import React from 'react';

import styles from '../BottomDrawer.module.scss';

interface BottomDrawerFooterProps {
    children?: React.ReactNode;
}

function BottomDrawerFooter({ children }: BottomDrawerFooterProps) {
    return <div className={styles.DrawerFooter}>{children}</div>;
}

export default BottomDrawerFooter;
